import React from 'react';
import styles from './ChartContainer.module.css';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AlertLabel from '../common/alertLabel/AlertLabel';

const ChartContainer = ({
    title,
    chartDescription,
    isLoading,
    errorMessage,
    isValueZero,
    noDataMessage = "No Data Available",
    children
}) => {
    return (
        <div className={styles['chart-container']}>
            <div className={styles['chart-header']}>
                <h2 className={styles['chart-title']}>{title}</h2>
                <Tooltip
                    arrow
                    title={chartDescription}
                >
                    <IconButton
                        aria-label="help"
                        sx={{ color: 'inherit' }}
                    >
                        <InfoOutlinedIcon />
                    </IconButton>
                </Tooltip>
            </div>

            <div className={styles['chart-content']}>
                {/* Show loading spinner */}
                {isLoading && (
                    <div className={styles['loading-container']}>
                        <CircularProgress className={styles['spinner-loader']} sx={{ color: "#264E5A" }} />
                    </div>
                )}

                {/* Show error message */}
                {!isLoading && errorMessage && (
                    <AlertLabel message={errorMessage} />
                )}

                {/* Show "No Data Available" message */}
                {!isLoading && !errorMessage && isValueZero && (
                    <AlertLabel message={noDataMessage} />
                )}

                {/* Render chart content */}
                {!isLoading && !errorMessage && !isValueZero && (
                    <div className={styles['chart-content-container']}>
                        {children}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ChartContainer;